import { api } from '@/lib/api';
import type { CafeDetailsRequest, CafeDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/cafe';

export async function save_cafe_details(
  input: CafeDetailsRequest,
): Promise<CafeDetailsResponse> {
  const res = await api.post<CafeDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_cafe_details(): Promise<CafeDetailsResponse | null> {
  const res = await api.get<CafeDetailsResponse | null>(URL);
  return res.data;
}
